exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n\n.BookCollectionDescription{\n\tposition: relative;\n\n\tfloat : left;\n\t\n\ttext-align: center;\n\twidth : 100%;\n\tmargin-right : auto;\n\tmargin-left : auto;\n}\n\n.BookCollectionSplash{\n\tposition: relative;\n\n\n\twidth:100%;\n}\n.BookCollectionGameInfos{\n\tposition: relative;\n\ttext-align: center;\n\n\twidth:90%;\n\t\n\tmargin-left: auto;\n    margin-right: auto;\n\n}\n.BookCollectionDLColo{\n\tdisplay: flex;\n\n\tcursor: pointer;\n\t\n\tborder-style: solid;\n\tborder-color: #fd7b00;\n\tborder-left-width: 6px;\n\tborder-right-width: 6px;\n\tborder-top-width: 3px;\n\tborder-bottom-width: 3px;\n\tborder-top-left-radius: 10px;\n\tborder-top-right-radius: 10px;\n\tborder-bottom-right-radius: 10px;\n\tborder-bottom-left-radius: 10px;\n\t\n\t\n\ttext-shadow: none;\n\tbackground-color: white;\n}\n.BookCollectionDLColo:hover{\n\tbackground-color: #e59f92;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./client/css/bookCollection.css
// module id = 76
// module chunks = 0